import { Text, Box, Stack } from '@ltvco/refresh-lib/theme';
import { ApiKeysList } from '@ltvco/refresh-lib/v1';
import { Code } from '@mui/icons-material';
import { useEffect } from 'react';

// import ApiInfo from './ApiInfo';
import { ApiStatus } from './ApiStatus/ApiStatus';
import { ApiUsageSection } from './ApiUsageSection/ApiUsageSection';

export function ApiPage() {
  useEffect(() => {
    document.title = 'BeenVerified API - BeenVerified';
  }, []);

  return (
    <Box mx={{ xs: 2, sm: 0 }}>
      <Text variant="h1" display="flex" alignItems="center">
        <Code fontSize="large" sx={{ mr: 2, color: 'primary.main' }} />
        BeenVerified API
      </Text>
      <Stack spacing={4}>
        <ApiStatus />
        <ApiKeysList />
        <ApiUsageSection />
        {/* TODO: Add ApiInfo when copy and docs are ready */}
        {/* <ApiInfo /> */}
      </Stack>
    </Box>
  );
}
